module.exports = __webpack_public_path__ + "static/media/edit.26ca380b.svg";